export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              关于蘑菇影院
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              了解蘑菇影院的故事与愿景
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-10">
            <div className="flex flex-col lg:flex-row gap-8 md:gap-10 items-center">
              <div className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 flex-shrink-0">
                <span className="text-2xl md:text-3xl font-heading font-bold">蘑</span>
              </div>
              <div className="flex-1">
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-4 text-center lg:text-left">
                  高清影视，触手可及
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  蘑菇影院诞生于对高清影视内容的热爱。我们深知每一位影迷对画质和流畅体验的追求，
                  因此致力于打造一个资源丰富、播放流畅、完全免费的高清影视平台。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  从最新高清电影到经典电视剧全集，从热门动作大片到小众文艺佳作，
                  蘑菇影院的片库涵盖多元类型，每日持续更新。我们采用先进的视频加速技术，
                  确保您在任何网络环境下都能享受流畅不卡顿的观影体验。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  未来，蘑菇影院将继续扩充高清资源，优化播放体验，成为您最信赖的在线观影伙伴。
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 md:mt-10">
              {[
                { value: '5年+', label: '运营时间' },
                { value: '20000+', label: '影视资源' },
                { value: '500万+', label: '月活用户' },
                { value: '99.9%', label: '播放成功率' },
              ].map((stat, i) => (
                <div key={i} className="text-center p-3 md:p-4 bg-background-100 rounded-xl border border-background-200/70">
                  <div className="text-xl md:text-2xl font-heading font-bold text-accent-600 mb-1">{stat.value}</div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}